import { NativeDateAdapter } from '@angular/material/core';
import format from 'date-fns/format';
import { CULLEN_DATE_FORMAT } from './cullen-date-formats';
import { parse } from 'date-fns';
import { Injectable } from '@angular/core';

@Injectable()
export class CullenDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      //console.log(format(date,'dd-MM-yyyy'));
      return format(date, CULLEN_DATE_FORMAT);
    }

    return date.toDateString();
  }

  parse(value: any): Date {
    return parse(value, CULLEN_DATE_FORMAT, new Date());
  }
}
